import { AppRoutes, NotificationTypes } from "../types/enums";

const mapper = {
  [NotificationTypes.account_plan_generation]: AppRoutes.ACCOUNT_PLAN,
  [NotificationTypes.sdr_playbook_generation]: AppRoutes.PLAYBOOK,
  [NotificationTypes.analysis]: AppRoutes.ACCOUNT,
  [NotificationTypes.scraping]: AppRoutes.ACCOUNT,
};

export const notificationLinkMapper = (
  type: NotificationTypes,
  campaignId: string,
  id: string,
) => {
  if ([NotificationTypes.analysis, NotificationTypes.scraping].includes(type)) {
    return `${mapper[type]}/${campaignId}/${id}`;
  }

  return `/${campaignId}${mapper[type]}/${id}`;
};
